import React, { useEffect } from "react";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import DatetimePicker from "../common/DatetimePicker";
import {
  dateToIso,
  formatScheduleHint,
  getDefaultScheduledDate,
} from "../common/scheduleUtils";

/**
 * Two-state schedule picker:
 *   "asap"       — sends scheduled_at = null
 *   "scheduled"  — sends an ISO timestamp (future, within 30 days)
 */
const ScheduleField = ({
  mode,
  scheduledAt,
  onModeChange,
  onScheduledAtChange,
  error,
}) => {
  useEffect(() => {
    if (mode === "scheduled" && !scheduledAt) {
      onScheduledAtChange(dateToIso(getDefaultScheduledDate()));
    }
  }, [mode, scheduledAt, onScheduledAtChange]);

  return (
    <Box>
      <RadioGroup value={mode} onChange={(e) => onModeChange(e.target.value)}>
        <FormControlLabel
          value="asap"
          control={<Radio size="small" />}
          label={
            <Typography sx={{ fontSize: 13 }}>Run as soon as approved (ASAP)</Typography>
          }
        />
        <FormControlLabel
          value="scheduled"
          control={<Radio size="small" />}
          label={<Typography sx={{ fontSize: 13 }}>Schedule for later</Typography>}
        />
      </RadioGroup>

      {mode === "scheduled" && (
        <Box sx={{ mt: 1, ml: 4 }}>
          <DatetimePicker
            label="Run at"
            value={scheduledAt}
            onChange={onScheduledAtChange}
            error={Boolean(error)}
            helperText={error || formatScheduleHint()}
          />
        </Box>
      )}
    </Box>
  );
};

export default ScheduleField;
